import React from 'react';
import { Navigate } from 'react-router-dom';
import HomeLayout from 'common/layouts/HomeLayout';
import AuthLayout from 'common/layouts/AuthLayout';
import SettingsLayout from 'areas/settings/components/settings-layout';
import Validate from 'areas/authentication/components/Validate';
import SelectOrg from 'areas/authentication/components/SelectOrg';
import Lost from 'areas/404/components';
import UnSubcribed from 'areas/404/components/NotSubscribed';
import NoAccess from 'areas/404/components/NoAccess';
import MemberSettings from 'areas/settings/components/user-settings/components/UserSettingsPage';
import RegisterToken from 'areas/authentication/components/RegisterToken';
import SetupPassword from 'areas/authentication/components/SetupPassword';
import ValidateEmail from 'areas/authentication/components/validate/Validate';
import NoLoginRole from 'areas/authentication/components/validate/Validate';
import Logout from 'areas/authentication/components/Logout';
import PortalRouter from './PortalRouter';
import { AdminRouter } from './AdminRouter';
import PrivacyPolicy from 'areas/authentication/components/PrivacyPolicy';
import TermsOfService from 'areas/authentication/components/TermsOfService';
import ProtectedRoute from '../common/components/ProtectedRoute';
import ContentShareLayout from 'areas/content-sharing/components/ContentShareLayout';
import ContentShareRedirect from 'areas/content-sharing/components/ContentShareRedirect';
import MobileRouter from '../mobile/MobileRouter';
import MobileAppLayout from '../mobile/MobileAppLayout';
import { PORTAL_ROUTES } from './routeConfig';

// Placeholder components for new routes
const Survey = () => <div>Survey Application</div>;

const routes = [
  {
    path: 'app/mobile/*',
    element: (
      <ProtectedRoute>
        <MobileAppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '*',
        element: <MobileRouter />,
      },
    ],
  },
  {
    path: 'app',
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/app/dashboard" />,
      },
      {
        path: 'content',
        element: <ContentShareLayout />,
      },
      {
        path: '*',
        element: (
          <ProtectedRoute>
            <PortalRouter />
          </ProtectedRoute>
        ),
      },
      {
        path: '404',
        element: <Lost />,
        role: 21,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'unsubscribed',
        element: <UnSubcribed />,
        role: 21,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'access-denied',
        element: <NoAccess />,
        role: 21,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
    ],
  },
  {
    path: '/settings',
    element: <AuthLayout />,
    children: [
      {
        path: 'select-organization',
        element: (
          <ProtectedRoute>
            <SelectOrg />
          </ProtectedRoute>
        ),
        role: 21,
        visible: false,
        team: false,
        paid: false,
      },
      {
        path: 'user', // profile page
        element: (
          <ProtectedRoute>
            <MemberSettings />
          </ProtectedRoute>
        ),
        role: 11,
        visible: true,
        team: false,
        paid: true,
      },
    ],
  },
  {
    path: '/settings/admin',
    element: <SettingsLayout />,
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute requiresStaffOrSuperUser={true}>
            <AdminRouter />
          </ProtectedRoute>
        ),
      },
      {
        path: '*',
        element: (
          <ProtectedRoute requiresStaffOrSuperUser={true}>
            <AdminRouter />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '/content',
    element: <ContentShareRedirect />,
  },
  {
    path: '/',
    element: <HomeLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/app" />,
      },
      {
        path: '404',
        element: <Lost />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'validate-email',
        element: <ValidateEmail />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'validate-survey-email',
        element: <NoLoginRole />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: 'account',
    element: <HomeLayout />,
    children: [
      {
        path: 'register-token/:token',
        element: <RegisterToken />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'auth/setup-password',
        element: <SetupPassword />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'setup-password',
        element: <SetupPassword />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'validate-account',
        element: <Validate />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'terms',
        element: <TermsOfService />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      {
        path: 'logout',
        element: <Logout />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: 'auth',
    element: <HomeLayout />,
    children: [
      {
        path: 'setup-password',
        element: <SetupPassword />,
        role: 11,
        visible: true,
        authentication: false,
        team: false,
        paid: false,
      },
    ],
  },
];

export default routes;
